import { Settings } from '../wrappers';
import { diContainer } from '../DIContainer';
import { AppStorageKey } from '../types';
export default class FiscalServiceElectron {
    sdcUrl;
    pac;
    key;
    cert;
    async init(options) {
        const { esdcUrl } = options;
        const appStorage = diContainer.resolve('appStorage');
        this.sdcUrl = esdcUrl;
        this.pac = await appStorage.native().getItem(AppStorageKey.sdcCertPac) || undefined;
        this.cert = await appStorage.native().getItem(AppStorageKey.sdcCert) || undefined;
        this.key = await appStorage.native().getItem(AppStorageKey.sdcCertKey) || undefined;
        await Settings.electron.invoke('sdcInit', {
            pac: this.pac,
            cert: this.cert,
            key: this.key,
            esdcUrl: this.sdcUrl
        });
    }
    async verifyPin(pin, sdc) {
        return await Settings.electron.invoke('sdcVerifyPin', { pin, sdc });
    }
    async createInvoice(invoice, sdc) {
        return await Settings.electron.invoke('sdcCreateInvoice', { invoice, sdc });
    }
    async getInvoice(requestId, sdc) {
        return await Settings.electron.invoke('sdcGetInvoice', { requestId, sdc });
    }
    async getEnvironmentParameters(sdc) {
        return await Settings.electron.invoke('sdcGetEnvironmentParameters', { sdc });
    }
    async getStatus(sdc) {
        return await Settings.electron.invoke('sdcGetStatus', { sdc });
    }
    async getAttention(sdc) {
        return await Settings.electron.invoke('sdcGetAttention', { sdc });
    }
    async getUiData(sdc) {
        return await Settings.electron.invoke('sdcGetUiData', { sdc });
    }
    async sendPendingAuditPackages(sdc) {
        return { error: { code: 'supported_only_on_esdc' } };
    }
    async reset(sdc) {
        return { error: { code: 'supported_only_on_esdc' } };
    }
    async storeLocalAuditFiles(sdc) {
        return { error: { code: 'supported_only_on_esdc' } };
    }
    async executeCommandsFromStorage(sdc) {
        return { error: { code: 'supported_only_on_esdc' } };
    }
    async chooseCertificate(password, pac) {
        const appStorage = diContainer.resolve('appStorage');
        const chooseCertificateResult = await Settings.electron.invoke('sdcCertChoose', password, pac);
        if (chooseCertificateResult.success) {
            appStorage.native().setItem(AppStorageKey.sdcCertPac, chooseCertificateResult.pac);
            appStorage.native().setItem(AppStorageKey.sdcCert, chooseCertificateResult.cert);
            appStorage.native().setItem(AppStorageKey.sdcCertKey, chooseCertificateResult.key);
            appStorage.native().setItem(AppStorageKey.sdcCertExpirationDate, chooseCertificateResult.expirationDate);
            this.pac = chooseCertificateResult.pac;
            this.cert = chooseCertificateResult.cert;
            this.key = chooseCertificateResult.key;
            await Settings.electron.invoke('sdcInit', {
                pac: this.pac,
                cert: this.cert,
                key: this.key,
                esdcUrl: this.sdcUrl
            });
        }
        return chooseCertificateResult;
    }
}
//# sourceMappingURL=FiscalServiceElectron.js.map